import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import styles from './EditProductCategoryModal.module.scss';
import { STATUS_OPTIONS } from '../../screens/AddProductCategory/AddProductCategoryConstants';
import { updateProductCategory } from '../../api/Products';

const EditProductCategoryModal = (props) => {
  const { show, onHide, category, token, onSuccess } = props;
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (category) {
      setFormData({
        categoryName: category.category || '',
        displayOrder: category.displayOrder || '',
        status: category.status,
        bannerImage1Large: category.bannerImg1 || '',
        bannerImage2Medium: category.bannerImg2 || '',
        bannerImage3Small: category.bannerImg3 || '',
        displayTitle: category.displayTitle || '',
        subTitle: category.subTitle || '',
      });
    }
  }, [category, show]);

  const handleInputChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.categoryName.trim()) {
      toast.error('Category name is required.');
      return;
    }

    setLoading(true);

    try {
      const categoryData = {
        category: formData.categoryName,
        displayOrder: parseInt(formData.displayOrder),
        status: formData.status.toUpperCase(),
        bannerImg1: formData.bannerImage1Large,
        bannerImg2: formData.bannerImage2Medium || null,
        bannerImg3: formData.bannerImage3Small || null,
        displayTitle: formData.displayTitle || null,
        subTitle: formData.subTitle || null,
      };

      await updateProductCategory(token, category.id, categoryData);
      toast.success('Product category updated successfully!');
      onSuccess();
      onHide();
    } catch (err) {
      toast.error('Failed to update product category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className={styles.editProductCategoryModal}
      size='lg'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Product Category</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label>Product Category ID</Form.Label>
            <Form.Control
              type='text'
              value={category?.id || ''}
              disabled
              readOnly
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Product Category Name *</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter category name'
              value={formData.categoryName || ''}
              onChange={(e) =>
                handleInputChange('categoryName', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Display Order *</Form.Label>
            <Form.Control
              type='number'
              placeholder='Enter Order'
              value={formData.displayOrder || ''}
              onChange={(e) =>
                handleInputChange('displayOrder', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Status *</Form.Label>
            <Form.Control
              as='select'
              className='form-select'
              value={formData.status}
              onChange={(e) => handleInputChange('status', e.target.value)}
            >
              {STATUS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Banner Image 1 (Large) *</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter banner image 1 URL'
              value={formData.bannerImage1Large || ''}
              onChange={(e) =>
                handleInputChange('bannerImage1Large', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Banner Image 2 (Medium)</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter banner image 2 URL'
              value={formData.bannerImage2Medium || ''}
              onChange={(e) =>
                handleInputChange('bannerImage2Medium', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Banner Image 3 (Small)</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter banner image 3 URL'
              value={formData.bannerImage3Small || ''}
              onChange={(e) =>
                handleInputChange('bannerImage3Small', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Display Title</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter title to display'
              value={formData.displayTitle || ''}
              onChange={(e) =>
                handleInputChange('displayTitle', e.target.value)
              }
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Sub Title</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter sub title to display'
              value={formData.subTitle || ''}
              onChange={(e) => handleInputChange('subTitle', e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant='primary' onClick={handleSubmit} disabled={loading}>
          {loading ? 'Updating...' : 'Update'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditProductCategoryModal;
